import DomainDto from './domain-dto';
import JobCodeDto from '../job/job-code-dto';
import ServiceDto from './service-dto';
import TechspecDto from '../job/techspec-dto';

export default class InvoiceDto
{
    public id: number|null = null;
    public techspec: TechspecDto|null = null;
    public service: ServiceDto|null = null;
    public domain: DomainDto|null = null;
    public invoiceNumber = '';
    public jobCode: JobCodeDto|null = null;
    public title = '';
    public notes: string|null = null;
    public paymentTerms: string|null = null;
    public amount = '0.00';
    public adwordsAmount = '0.00';
    public miscAmount = '0.00';
    public dateRequested = '';
    public dateSent: string|null = null;
    public datePaid: string|null = null;
    public dateReminder1: string|null = null;
    public dateReminder2: string|null = null;
    public dateCreditNote: string|null = null;
}